import { Alert } from '../../components/alert/alert';
import { setValid, validateFormFields, validateStep } from "@assets/ts/prisijungimo_salygos";
/** exposinam wizardo middleware */
if (typeof $ !== 'function') {
    window['$'] = jQuery;
}
window['validateStep'] = validateStep;
var objectSelect = document.getElementById('ObjectType'), formRender = document.getElementById('renderForm');
var formToRender;
var isFirstTime = document.getElementById('IsFirstTime');
var isExistingClient = document.getElementById('IsExistingClient');
var selectedIndex1;
var SubmitingPerson = document.getElementById('SubmitingPerson');
$(SubmitingPerson).change(function (e) {
    var selectedIndex = document.getElementById("SubmitingPerson").selectedIndex;
    selectedIndex1 = selectedIndex;
    togglePlannerRequired(SubmitingPerson.value);
    if (formToRender) {
        showLoading('Kraunasi');
        var _selectedIndex = document.getElementById("SubmitingPerson").selectedIndex;
        $.ajax({
            method: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: {
                action: 'psnobjects',
                formToRender: formToRender,
                selectedIndex: _selectedIndex
            },
            success: function success(data) {
                var tmp = document.createElement('div');
                formRender.innerHTML = '';
                tmp.innerHTML = data;
                formRender.appendChild(tmp);
                listeners();
                stopLoading();
            }
        });
    }
});
$(isExistingClient).change(function (e) {
    switch (e.currentTarget.value) {
        case '1':
            $('#ClientCode').closest('.row').removeClass('d-none').end().removeAttr('disabled');
            break;
        case '0':
            $('#ClientCode').closest('.row').addClass('d-none').end().attr('disabled', 'true');
            break;
    }
});
$(isFirstTime).change(function (e) {
    switch (e.currentTarget.value) {
        case '1':
            $('#TermsNumber, #SubmitReason').closest('.row').removeClass('d-none').end().removeAttr('disabled');
            break;
        case '0':
            $('#TermsNumber, #SubmitReason').closest('.row').addClass('d-none').end().attr('disabled', 'true');
            break;
    }
});
$(objectSelect).change(function (e) {
    var docsWrap = document.getElementById('docs');
    if (docsWrap) {
        docsWrap.innerHTML = '';
    }
    if (!e.target.value) {
        formRender.innerHTML = '';
    }
    ;
    switch (e.target.value) {
        case '0':
            formToRender = 'vienbutis';
            break;
        case '1':
            formToRender = 'dvibutis';
            break;
        case '2':
            formToRender = 'butas';
            break;
        case '3':
            formToRender = 'namas';
            break;
    }
    showLoading('Kraunasi');
    var selectedIndex = document.getElementById("SubmitingPerson").selectedIndex;
    $.ajax({
        method: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: {
            action: 'psnobjects',
            formToRender: formToRender,
            selectedIndex: selectedIndex
        },
        success: function success(data) {
            var tmp = document.createElement('div');
            formRender.innerHTML = '';
            tmp.innerHTML = data;
            formRender.appendChild(tmp);
            listeners();
            stopLoading();
        }
    });
});
function listeners() {
    var submitingPersonSelect = document.getElementById('SubmitingPerson');
    var objectStatusSelect = document.getElementById('ObjectStatus');
    var statusSelect = document.getElementById('ObjectStatus');
    var statusId = document.getElementById('ObjectStatus').value;
    var typeId = document.getElementById('SubmitingPerson').value;
    var objectType = document.getElementById('ObjectType').value;
    if (typeId && statusId) {
        var docsWrap = document.getElementById('docs');
        showLoading('Kraunasi');
        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: 'POST',
            data: {
                action: 'psnfiles',
                TypeId: typeId,
                StatusId: statusId,
                ObjectType: objectType
            },
            success: function success(data) {
                var tmp = document.createElement('div');
                tmp.innerHTML = data;
                docsWrap.innerHTML = '';
                docsWrap.appendChild(tmp);
                fileInputListener();
                stopLoading();
            }
        });
    }
    $(submitingPersonSelect).change(loadFiles);
    $(objectStatusSelect).change(loadFiles);
    $(statusSelect).change(loadFiles);
    var forFiresSelect = document.getElementById('ForFires');
    $(forFiresSelect).change(function (e) {
        var forFiresVolume = document.getElementById('ForFiresVolumeH');
        if (forFiresSelect) {
            if (e.target.value == '0') {
                forFiresVolume.removeAttribute('disabled');
                $(forFiresVolume).closest('.row').removeClass('d-none');
            }
            else {
                forFiresVolume.setAttribute('disabled', true);
                $(forFiresVolume).closest('.row').addClass('d-none');
            }
        }
    });
    if (selectedIndex1 == 2) {
        $('#textMessage1').removeClass('d-none');
        $("#textMessage1").show();
        $("#textMessage").hide();
    }
    else {
        $("#textMessage1").hide();
        $("#textMessage").show();
        $('#textMessage').removeClass('d-none');
    }
    $('#Services').change(function (e) {
        var val = e.currentTarget.value;
        switch (val) {
            case '0':
                $('#VolumeD, #VolumeH, #VolumeSewageD, #VolumeSewageH').closest('.row').removeClass('d-none').end().removeAttr('disabled');
                $('#FromWell, #IsLocalSewage').closest('.row').addClass('d-none').end().attr('disabled', 'true');
                break;
            case '1':
                $('#VolumeD, #VolumeH, #VolumeSewageD, #VolumeSewageH,#FromWell ').closest('.row').addClass('d-none').end().attr('disabled', 'true');
                $('#VolumeD, #VolumeH,#IsLocalSewage').closest('.row').removeClass('d-none').end().removeAttr('disabled');
                break;
            case '2':
                $('#IsLocalSewage,#VolumeD, #VolumeH, #VolumeSewageD, #VolumeSewageH').closest('.row').addClass('d-none').end().attr('disabled', 'true');
                $('#VolumeSewageD, #VolumeSewageH,#FromWell').closest('.row').removeClass('d-none').end().removeAttr('disabled');
                break;
        }
    });
}
function loadFiles(e) {
    var docsWrap = document.getElementById('docs');
    if (!e.target.value) {
        docsWrap.innerHTML = '';
        return;
    }
    var statusId = document.getElementById('ObjectStatus').value, typeId = document.getElementById('SubmitingPerson').value, objectType = document.getElementById('ObjectType').value;
    if (objectType == "2" && statusId == "2") {
        $('#ApartmentDividedUnitsCount').removeAttr('readonly').attr('required', true).removeClass('readonly');
        $('#ApartmentDividedUnitsCountWrap').removeClass('d-none');
        $('#ApartmentDividedUnitsCountWrap').find('.control-wrap').addClass('required');
    }
    else {
        $('#ApartmentDividedUnitsCount').attr('readonly', "true").removeAttr('required', "false").addClass('readonly');
        $('#ApartmentDividedUnitsCountWrap').addClass('d-none');
        $('#ApartmentDividedUnitsCountWrap').find('.control-wrap').removeClass('required');
    } // ON CHANGE
    if (statusId == '1') {
        $('#Services').find('.control--pseudo').attr('readonly', 'true').addClass('readonly').val(0).trigger('change');
        $('#Services').val(0);
        $('#HasContract, #UsesWell').closest('.row').addClass('d-none').end().attr('disabled', 'true');
    }
    else {
        $('#Services').find('.control--pseudo').removeAttr('readonly', 'true').removeClass('readonly').trigger('change');
        $('#Services').val(-1);
        $('#HasContract, #UsesWell').closest('.row').removeClass('d-none').end().removeAttr('disabled');
    } // LOAD DOCS
    if (!statusId) {
        e.preventDefault();
        docsWrap.innerHTML == '';
        xalert('Pasirinkite objekto būklę');
    }
    else if (statusId && !typeId) {
        return;
    }
    else {
        showLoading('Kraunasi');
        $.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: 'POST',
            data: {
                action: 'psnfiles',
                TypeId: typeId,
                StatusId: statusId,
                ObjectType: objectType
            },
            success: function success(data) {
                var tmp = document.createElement('div');
                tmp.innerHTML = data;
                docsWrap.innerHTML = '';
                docsWrap.appendChild(tmp);
                fileInputListener();
                stopLoading();
            }
        });
    }
    togglePlannerRequired(typeId);
}
;
function togglePlannerRequired(typeId) {
    var plannerFields = $('#plannerFields').find('[name]');
    if (typeId == '1') {
        plannerFields.each(function (i, el) {
            $(el).closest('.col').addClass('required').end().attr('required', 'true');
            setValid(el);
        });
    }
    else {
        plannerFields.each(function (i, el) {
            $(el).closest('.col').removeClass('required').end().removeAttr('required');
            setValid(el);
        });
    }
}
var buttonClicked = false;
$('#requestForm').submit(function (e) {
    e.preventDefault();
    var cpt = window['grecaptcha'];
    if (!cpt || !cpt.getResponse()) {
        xalert('Patvirtinkite reCAPTCHA');
        return false;
    }
    var isValid = validateFormFields(this);
    $('#requestForm input[type="file"]').each(function (i, el) {
        var inputCount = $(el).closest('.col').find('.file-upload').length;
        if (!el.value && inputCount > 1) {
            $(el).closest('.file-upload').remove();
        }
    });
    if (!isValid) {
        xalert('Užpildykite privalomus laukus');
        var firstInvalid = $('.border-danger')[0];
        if (firstInvalid) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(firstInvalid).offset().top - 100
            }, 300);
        }
        return false;
    }
    else {
        var formData = new FormData(this);
        var submitBtn = $('#formSubmit');
        if (buttonClicked) {
            return;
        }
        buttonClicked = true;
        submitBtn.attr('disabled', 'true'); // $('#loading-card').removeClass('loading-hidden');
        showLoading('Įkeliami dokumentai');
        try {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: formData,
                success: function success(data) {
                    var res = {
                        success: false,
                        message: 'Ivyko klaida. Bandykite iš naujo.'
                    };
                    try {
                        res = JSON.parse(data);
                    }
                    catch (err) {
                        console.warn('RESPONSE KLAIDA');
                    }
                    $('#loading-card').addClass('loading-hidden');
                    if (!res.success) {
                        // if (res.reset_captcha) {
                        //     resetCaptcha();
                        // }
                        var message = res.message;
                        if (!res.message) {
                            message = 'Patikrinkite duomenis ir pateikite iš naujo';
                        }
                        xalert(message);
                        submitBtn.removeAttr('disabled');
                        buttonClicked = false;
                    }
                    else {
                        $.ajax({
                            url: '/wp-admin/admin-ajax.php',
                            type: 'POST',
                            data: {
                                action: 'psnsuccess'
                            },
                            success: function success(content) {
                                new Alert({
                                    content: content,
                                    url: window.location.href,
                                    type: 'success'
                                });
                            }
                        });
                    }
                },
                contentType: false,
                processData: false
            });
        }
        catch (err) {
            xalert('Įvyko klaida. Bandykite dar kartą.');
            submitBtn.removeAttr('disabled');
            buttonClicked = false;
        }
    }
});
function showLoading(text) {
    var loadingBox = $('#loading-card'), loadingText = loadingBox.find('.loading-text');
    loadingText.text(text);
    loadingBox.removeClass('loading-hidden');
    $('button#formSubmit').attr('disabled', true);
}
function stopLoading() {
    $('#loading-card').addClass('loading-hidden');
    $('button#formSubmit').removeAttr('disabled');
}
function setInputFilter(textbox, inputFilter) {
    ["input", "keydown", "keyup", "mousedown", "mouseup", "select", "contextmenu", "drop"].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            }
            else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
        textbox.classList.add('control-listener');
    });
} // Restrict input to digits and '.' by using a regular expression filter.
function inputMasks() {
    var phones = document.querySelectorAll('input[data-type="xphone"]:not(.control-listener)');
    phones.forEach(function (el) {
        setInputFilter(el, function (value) {
            return /^\d*$/.test(value);
        });
        $(el).change(function (e) {
            var re = /^6(?=)\d{7}(?=)$/;
            var el = $(e.currentTarget), message = '<span class="invalid-mail text-danger">Neteisingas telefono formatas</span>';
            if (el.val() && !re.test(el.val())) {
                $(el).closest('.col').find('span.invalid-mail').remove();
                $(el).closest('.col').append(message);
            }
            else {
                $(el).closest('.col').find('span.invalid-mail').remove();
            }
        });
    });
    var mails = document.querySelectorAll('input[type="email"]:not(.control-listener)');
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    mails.forEach(function (el) {
        var reStr = "".concat(re);
        reStr = reStr.slice(1, reStr.length - 2);
        el.setAttribute('pattern', reStr);
        el.addEventListener('blur', function (e) {
            var el = $(e.currentTarget), message = '<span class="invalid-mail text-danger">Neteisingas el. pašto formatas</span>';
            if (el.val() && !re.test(el.val())) {
                $(el).siblings('span.invalid-mail').remove();
                $(el).closest('.col').append(message);
            }
            else {
                $(el).siblings('span.invalid-mail').remove();
            }
        });
    });
}
function isInArray(value, array) {
    return array.indexOf(value) > -1;
}
inputMasks();
function fileInputListener() {
    var invalidateSteps = function invalidateSteps(step) {
        if (!step)
            return;
        if (!step.classList.contains('wizard-step'))
            return;
        step.classList.remove('wizard-step--valid');
        invalidateSteps(step.nextElementSibling);
    };
    var docsStep = document.querySelector('.wizard-step[data-step-id="fileFields"');
    docsStep && invalidateSteps(docsStep);
    $('input[type="file"]:not(.rendered)').each(function (i, el) {
        $(el).change(function (e) {
            var ext = e.currentTarget.value.split('.').pop();
            var input = $(e.currentTarget), text = input.closest('.file-upload').find('input[type="text"]'), remove = input.closest('.file-upload').find('button.file-upload-remove'), add = input.closest('.file-upload').find('button.file-upload-add');
            if (!isInArray(ext, ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'pdf', 'doc', 'docx', 'zip'])) {
                // xalert(ext);
                xalert('Įkelkite dokumentus gif, jpg, png, bmp, pdf, doc, docx arba zip formatu');
                input.val('');
                text.val('');
            }
            text.val(input[0].files[0].name);
            input.addClass('rendered');
            input.closest('.file-upload').addClass('has-value');
        });
    });
}
var alertCard = $('#alert-card'), alertBtn = alertCard.find('#alertButton');
alertBtn.click(function (e) {
    e.preventDefault();
    alertCard.addClass('d-none');
    document.removeEventListener('keydown', onEscapeAlert);
});
var onEscapeAlert = function onEscapeAlert(_ref) {
    var key = _ref.key;
    if (!key)
        return;
    if (key.toUpperCase() === 'ESCAPE') {
        alertCard.addClass('d-none');
        document.removeEventListener('keydown', onEscapeAlert);
    }
};
function xalert(msg) {
    document.addEventListener('keydown', onEscapeAlert);
    var msgEl = document.getElementById('alertText');
    alertCard.removeClass('d-none');
    alertBtn.focus();
    msgEl.innerText = msg;
}
